import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import _sliceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/slice';
import _Object$assign from '@babel/runtime-corejs3/core-js-stable/object/assign';
import { c as classNames } from '../../shared/bind-a2a3a613.js';
import { jsx } from 'react/jsx-runtime';

var styles = {
  "unit-base": "4",
  "card": "web_ui__Card__card",
  "lifted": "web_ui__Card__lifted",
  "elevated": "web_ui__Card__elevated",
  "primaryLightExperimental": "web_ui__Card__primaryLightExperimental",
  "exposeLightExperimental": "web_ui__Card__exposeLightExperimental",
  "overflowAuto": "web_ui__Card__overflowAuto",
  "overflowHidden": "web_ui__Card__overflowHidden",
  "overflowScroll": "web_ui__Card__overflowScroll",
  "overflowVisible": "web_ui__Card__overflowVisible"
};

/* ---------- String-union sources of truth ---------- */
var CARD_STYLING_VALUES = ['lifted', 'elevated'];
var CARD_THEME_VALUES = ['primaryLightExperimental', 'exposeLightExperimental'];

/* ---------- Back-compat shims (public API) ---------- */
var CARD_STYLING = {
  Lifted: 'lifted',
  Elevated: 'elevated'
};

/* ---------- Type definitions ---------- */

var cssClasses = classNames.bind(styles);
var CardBase = function CardBase(_ref) {
  var _context;
  var styling = _ref.styling,
    children = _ref.children,
    testId = _ref.testId,
    experimentalTheme = _ref.experimentalTheme,
    _ref$overflow = _ref.overflow,
    overflow = _ref$overflow === void 0 ? 'auto' : _ref$overflow;
  var overflowClass = _concatInstanceProperty(_context = "overflow".concat(overflow.charAt(0).toUpperCase())).call(_context, _sliceInstanceProperty(overflow).call(overflow, 1));
  var cardClass = cssClasses(styles.card, styling, experimentalTheme, overflowClass);
  return /*#__PURE__*/jsx("div", {
    className: cardClass,
    "data-testid": testId,
    children: children
  });
};

/** The public component type: a React component value that also has deprecated statics */

/** Exported component: arrow fn + statics, deprecations intact, docgen-friendly */
var Card = _Object$assign(CardBase, {
  /** @deprecated Use string unions, e.g. styling="lifted" */
  Styling: CARD_STYLING
});

export { CARD_STYLING, CARD_STYLING_VALUES, CARD_THEME_VALUES, Card, Card as default };
//# sourceMappingURL=Card.js.map
